import { axios } from '@ben/api/axios';
import type { RenewalConfig } from '@ben/shared/types/columbia';
import type { UseMutationOptions } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';

export interface ScheduledVersionPayload {
  benefitId?: string;
  renewalConfig: RenewalConfig;
}

interface ScheduledVersionResponse {
  enrollableBenefitId: number;
}

const createScheduledVersion = async ({
  benefitId,
  renewalConfig,
}: ScheduledVersionPayload) => {
  const response = await axios.post<ScheduledVersionResponse>(
    `benefits/${benefitId}/versions/`,
    renewalConfig
  );
  return response.data;
};

export const useMutationCreateScheduledVersion = (
  options?: UseMutationOptions<
    ScheduledVersionResponse,
    unknown,
    ScheduledVersionPayload
  >
) => {
  return useMutation<
    ScheduledVersionResponse,
    unknown,
    ScheduledVersionPayload
  >({
    ...options,
    mutationFn: (payload: ScheduledVersionPayload) => {
      if (!payload.benefitId) {
        return Promise.reject(new Error('benefitId must be provided'));
      }
      return createScheduledVersion(payload);
    },
  });
};
